import { render, staticRenderFns } from "./ANZHTML.vue?vue&type=template&id=18a9baeb"
import script from "./ANZHTML.vue?vue&type=script&lang=js"
export * from "./ANZHTML.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports